export default class InitialProcessSetupService {
	constructor(apiService) {
		this.apiService = apiService
	}

	getEntity(id, params) {
		return this.apiService.callGet('me/initialProcessSetup/' + id, params)
	}

	getEntities(params) {
		return this.apiService.callGet('me/initialProcessSetup', params)
	}

	getSettings(){
		return this.apiService.callGet('me/initialProcessSetup/settings');
	}

	updateEntity(id, params) {
		return this.apiService.callPut('me/initialProcessSetup/'+id, params)
	}

	createEntity(params){
		return this.apiService.callPost('me/initialProcessSetup/', params);
	}

	deleteEntity(id) {
		return this.apiService.callDelete('me/initialProcessSetup/'+id)
	}
}



// WEBPACK FOOTER //
// ./src/service/InitialProcessSetupService.js